// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingScreen_container__htLb6","onBoardingScreen":"OnBoardingScreen_onBoardingScreen__bpRx9","hide":"OnBoardingScreen_hide__sy8Ii"};